<template>
  <div class="app-payment-information summary-content">
    <slot name="txtBefore"></slot>
    <ShowCreditCardInformation v-if="isCreditCard" :credit-card-information="payment">
      <template #txtBefore><slot name="txtBeforeCreditCard"></slot></template>
      <template #lblCcHolder><slot name="lblCcHolderCreditCard"></slot></template>
      <template #lblCcNumber><slot name="lblCcNumberCreditCard"></slot></template>
      <template #lblCcType><slot name="lblCcTypeCreditCard"></slot></template>
      <template #lblCcValidty><slot name="lblCcValidtyCreditCard"></slot></template>
      <template #txtAfter><slot name="txtAfterCreditCard"></slot></template>
      <template #txtError><slot name="txtErrorCreditCard"></slot></template>
    </ShowCreditCardInformation>
    <ShowBankAccountInformation v-if="isBankAccount" :bank-account="payment" :customer="currentCustomer">
      <template #txtBefore><slot name="txtBeforeBankAccount"></slot></template>
      <template #lblOwner><slot name="lblOwnerBankAccount"></slot></template>
      <template #lblIban><slot name="lblIbanBankAccount"></slot></template>
      <template #txtAfter><slot name="txtAfterBankAccount"></slot></template>
    </ShowBankAccountInformation>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import ShowCreditCardInformation from './ShowCreditCardInformation.vue'
import ShowBankAccountInformation from './ShowBankAccountInformation.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
export default {
  name: 'PaymentInformation',
  components: { ShowBankAccountInformation, ShowCreditCardInformation },
  data() {
    return {
      currentCustomer: {
        firstName: '',
        lastName: ''
      }
    }
  },
  computed: {
    isCreditCard() {
      return this.payment.type === 'creditCard'
    },
    isBankAccount() {
      return this.payment.type === 'bankAccount'
    }
  },
  props: {
    payment: {
      type: Object
    }
  },
  apollo: {
    currentCustomer: function() {
      return wrapQuery(
        gql`
          query personalData {
            currentCustomer {
              firstName
              lastName
            }
          }
        `,
        this,
        'currentCustomer'
      )
    }
  }
}
</script>
